export * from "./DetailsBar";
